import {useCallback} from 'react';

export const useAppEventDispatch = () => {
  return useCallback((event: string) => {
    window.dispatchEvent(new CustomEvent(event));
  }, []);
};
